import type { PackageItemVariant } from './PackageItemVariant'

export const PackageItemTypeCategory = {
    Common: 0,
    Realty: 1,
    Household: 2,
    Basic: 3,
    Addons: 4
} as const

export type PackageItemTypeCategory = typeof PackageItemTypeCategory[keyof typeof PackageItemTypeCategory]

export const PackageItemLimitType = {
    Boolean: 1,
    Limit: 2
} as const

export type PackageItemLimitType = typeof PackageItemLimitType[keyof typeof PackageItemLimitType]

export interface PackageItemModel {
    riskId: number
    riskName: string
    description: string
    packageItemId?: number
    packageId?: number
    addable: boolean
    included: boolean
    limitType?: PackageItemLimitType
    category?: PackageItemTypeCategory
    variants: PackageItemVariant[]
    isAddition: boolean,
    selectedVariant?: PackageItemVariant
}

export interface UpdateOfferPackageDto {
    offerId: number
    packages: UpdateOfferPackageGroupDto[]
}

export interface UpdateOfferPackageGroupDto {
    packageId: number
    groupId: number
}